import { CarouselItem } from '../../models/LessonComponentContent';
import LessonComponentService from '../../services/LessonComponentService';
import React from 'react';
import componentStyles from '../../styles/LessonComponents.module.css';
import styles from '../../styles/Carousel.module.css';
import useThemes from '../../../shared/hooks/useThemes';

export default function CarouselItemViewer(props: {
  currentIndex: number;
  items: CarouselItem[];
}) {
  const isEmpty = !props.items.some(
    (c) =>
      LessonComponentService.getFilteredContent(c.heading) ||
      LessonComponentService.getFilteredContent(c.body)
  );

  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;

  if (isEmpty) return null;

  return (
    <div
      className={`${styles.itemContainer} ${componentStyles.textOverflow}`}
      style={{ fontFamily }}
    >
      {props.items.map((item, index) => (
        <div
          className={`${styles.itemContent} ${
            index === props.currentIndex ? styles.active : ''
          }`}
          key={index}
        >
          <div className="style-h2">
            <span
              className="ql-editor"
              dangerouslySetInnerHTML={{
                __html: LessonComponentService.getUrlWithSas(item.heading)
              }}
            ></span>
          </div>
          <div className={`style-p ${styles.bodyText}`}>
            <span
              className="ql-editor"
              dangerouslySetInnerHTML={{
                __html: LessonComponentService.getUrlWithSas(item.body)
              }}
            ></span>
          </div>
        </div>
      ))}
    </div>
  );
}
